import { authClient, API } from '../index'

// Count all FAQs
export const countFAQs = () => {
  return authClient().get(`${API}/faq/count`)
}

// Get all FAQs
export const getFAQs = () => {
  return authClient().get(`${API}/faq`)
}

// Get FAQ by id
export const getFAQById = (id) => {
  return authClient().get(`${API}/faq/${id}`)
}

// Update FAQ
export const updateFAQ = (id, faq) => {
  return authClient().put(`${API}/faq/${id}`, faq)
}

// Create FAQ
export const postFAQ = (faq) => {
  return authClient().post(`${API}/faq`, faq)
}

// Delete FAQ
export const deleteFAQ = (id) => {
  return authClient().delete(`${API}/faq/${id}`)
}

